import LoginRegisterTransferLink from '@map/components/GuestArea/LoginRegisterTransferLink';
import { guestLinks } from '@map/components/GuestArea/links';
import { FormPasswordField, FormPhoneField } from '@map/components/formControls/controlled';
import { useUpdateAuthenticationFlow } from '@map/hooks/flows/authentication';
import { usePhoneNumberVerification } from '@map/hooks/usePhoneNumberVerification';
import { userValidationSchema } from '@map/validators/user';
import { Typography } from '@mui/material';
import { useFormatMessage } from '@shared/hooks/intl';
import Form, { SubmitButton, SubmitFunction } from '@shared/lib/form/Form';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import PublicPage from '../../shared/PublicPage';
import PhoneEmailTransferButton from '../PhoneEmailTransferButton';
import { useRegistrationContext } from '../context';

const pluckedValidationSchema = userValidationSchema.pick(['phone', 'password']);

const Phone = () => {
  const history = useHistory();
  const { request } = usePhoneNumberVerification();
  const { updateValues } = useRegistrationContext();
  const updateAuthenticationFlow = useUpdateAuthenticationFlow();
  updateAuthenticationFlow({ method: 'phone' });
  const t = useFormatMessage();
  const handleSubmit = useCallback<SubmitFunction<{ phone: string; password: string }>>(
    async (values, { setFieldError }) => {
      try {
        const req = await request(values.phone, 'register');
        if (req.success) {
          updateValues({ phoneVerificationRequest: req, ...values });
          history.push(guestLinks.registerPhoneVerify());
        } else {
          // i18n-tasks-use t('phone_number_verification.rate_limit')
          setFieldError('phone', 'phone_number_verification.rate_limit');
        }
      } catch (e) {
        console.warn(e);
      }
    },
    [history, request, updateValues],
  );

  return (
    <PublicPage
      title={<FormattedMessage id="registration.sign_up_button" />}
      footer={<LoginRegisterTransferLink to="login" variant="minimal" />}
    >
      <Form
        initialValues={{ phone: '', password: '' }}
        validationSchema={pluckedValidationSchema}
        onSubmit={handleSubmit}
      >
        <FormPhoneField
          name="phone"
          autoComplete="tel"
          placeholder={t('registration.phone_number_label')}
        />
        <FormPasswordField
          name="password"
          placeholderIntlKey="registration.password_label"
          autoComplete="new-password"
          helperText={
            <Typography variant="body3" color="neutrals.600">
              <FormattedMessage id="registration.password_helper" />
            </Typography>
          }
        />

        <SubmitButton fullWidth={true} size="medium">
          <FormattedMessage id="registration.next" />
        </SubmitButton>
        <PhoneEmailTransferButton to="email" />
      </Form>
    </PublicPage>
  );
};

export default Phone;
